import React from "react";
import styled from "styled-components";
import { FiGlobe } from "react-icons/fi";
import { colors } from "./colors";
import { formatDayYear } from "./format";
import { RANGES, COMPARES } from "./traffic";
import Segmented from "./Segmented";
import { Dot } from "./SeverityBadge";

export default function Header({ site, range, compare, onRangeChange, onCompareChange }) {
    return (
        <Bar>
            <div>
                <Title>Drop overview</Title>
                <Subtitle>
                    <FiGlobe aria-hidden />
                    <strong>{site.domain}</strong>
                    <span>· Search Console data through {formatDayYear(site.dataThrough)}</span>
                    <Synced><Dot $color={colors.positive} />{site.syncedLabel}</Synced>
                </Subtitle>
            </div>
            <Controls>
                <Segmented ariaLabel="Date range" options={RANGES} value={range} onChange={onRangeChange} />
                <Segmented ariaLabel="Compare to" options={COMPARES} value={compare} onChange={onCompareChange} />
            </Controls>
        </Bar>
    );
}

const Bar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
    @media (max-width: 600px) { padding: 0 16px; }
`;

const Title = styled.h1`
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.01em;
    color: ${colors.ink};
`;

const Subtitle = styled.p`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin: 2px 0 0;
    font-size: 14px;
    color: ${colors.muted};
    svg { color: ${colors.subtle}; }
    strong { font-weight: 500; color: ${colors.ink}; }
`;

const Synced = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding-left: 8px;
    font-size: 12px;
`;

const Controls = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;
